import { useEffect, useState } from "react";
import { Layout } from "antd";
import * as Components from "../../components";
import { useWindowSize } from "../../hooks/useWindowSize";
import sad from "../../assets/images/sad.png";

function Sale(props) {
  const [width] = useWindowSize();
  const [activeTable, setActiveTable] = useState(null);
  const [activeProduct, setActiveProduct] = useState({});

  useEffect(() => {
    document.title = "Заал";
  }, []);

  return width < 756 ? (
    <div className="flex items-center justify-center h-full flex-col">
      <img src={sad} alt="chef" className="mb-4 h-20 w-20" />
      <span className="text-primary font-semibold w-52 text-center">
        Уучлаарай ажиллах боломжгүй төхөөрөмж байна.(Гар утаснаас борлуулалт
        хийх боломжгүй)
      </span>
    </div>
  ) : (
    <Layout className="p-4 bg-fullBack h-full flex flex-row">
      <Components.OrderCategory {...props} />
      <div className="grid grid-cols-12 gap-3 h-full w-full">
        {/* Ангиллын жагсаалт */}

        {/* Ангилалд хамаарах бараануудын жагсаалт */}
        <Components.OrderProducts
          {...props}
          activeProduct={activeProduct}
          setActiveProduct={setActiveProduct}
          activeTable={activeTable}
          setActiveTable={setActiveTable}
        />
        <div className="col-span-6 sm:col-span-6 md:col-span-6 lg:col-span-6 xl:col-span-4 2xl:col-span-4 flex flex-col">
          {/* Захиалгын хүснэгт */}
          <Components.OrderTable
            {...props}
            activeProduct={activeProduct}
            setActiveProduct={setActiveProduct}
            activeTable={activeTable}
          />
          <Components.OrderPayment
            {...props}
            activeTable={activeTable}
            setActiveTable={setActiveTable}
          />
        </div>
      </div>
    </Layout>
  );
}
export default Sale;
